import client from 'client'
import type {
  CreateAssetPositionAssetLinkAssetPositionLinkPostMutationRequest,
  CreateAssetPositionAssetLinkAssetPositionLinkPostMutationResponse,
  CreateAssetPositionAssetLinkAssetPositionLinkPostQueryParams,
  CreateAssetPositionAssetLinkAssetPositionLinkPost422,
} from '../../types/CreateAssetPositionAssetLinkAssetPositionLinkPost.ts'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { RequestConfig, ResponseConfig, ResponseErrorConfig } from 'client'
import { useMutation } from '@tanstack/react-query'

export const createAssetPositionAssetLinkAssetPositionLinkPostMutationKey = () => [{ url: '/asset_position/link' }] as const

export type CreateAssetPositionAssetLinkAssetPositionLinkPostMutationKey = ReturnType<typeof createAssetPositionAssetLinkAssetPositionLinkPostMutationKey>

/**
 * @summary Create Asset Position Asset Link
 * {@link /asset_position/link}
 */
export async function createAssetPositionAssetLinkAssetPositionLinkPost(
  data: CreateAssetPositionAssetLinkAssetPositionLinkPostMutationRequest,
  params?: CreateAssetPositionAssetLinkAssetPositionLinkPostQueryParams,
  config: Partial<RequestConfig<CreateAssetPositionAssetLinkAssetPositionLinkPostMutationRequest>> & { client?: typeof client } = {},
) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<
    CreateAssetPositionAssetLinkAssetPositionLinkPostMutationResponse,
    ResponseErrorConfig<CreateAssetPositionAssetLinkAssetPositionLinkPost422>,
    CreateAssetPositionAssetLinkAssetPositionLinkPostMutationRequest
  >({ method: 'POST', url: `/asset_position/link`, params, data, ...requestConfig })
  return res
}

/**
 * @summary Create Asset Position Asset Link
 * {@link /asset_position/link}
 */
export function useCreateAssetPositionAssetLinkAssetPositionLinkPost(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<CreateAssetPositionAssetLinkAssetPositionLinkPostMutationResponse>,
      ResponseErrorConfig<CreateAssetPositionAssetLinkAssetPositionLinkPost422>,
      { data: CreateAssetPositionAssetLinkAssetPositionLinkPostMutationRequest; params?: CreateAssetPositionAssetLinkAssetPositionLinkPostQueryParams }
    >
    client?: Partial<RequestConfig<CreateAssetPositionAssetLinkAssetPositionLinkPostMutationRequest>> & { client?: typeof client }
  } = {},
) {
  const { mutation: mutationOptions, client: config = {} } = options ?? {}
  const mutationKey = mutationOptions?.mutationKey ?? createAssetPositionAssetLinkAssetPositionLinkPostMutationKey()

  return useMutation<
    ResponseConfig<CreateAssetPositionAssetLinkAssetPositionLinkPostMutationResponse>,
    ResponseErrorConfig<CreateAssetPositionAssetLinkAssetPositionLinkPost422>,
    { data: CreateAssetPositionAssetLinkAssetPositionLinkPostMutationRequest; params?: CreateAssetPositionAssetLinkAssetPositionLinkPostQueryParams }
  >({
    mutationFn: async ({ data, params }) => {
      return createAssetPositionAssetLinkAssetPositionLinkPost(data, params, config)
    },
    mutationKey,
    ...mutationOptions,
  })
}